import React from 'react';
import Content from './Content';
import Discover from './Discover';
import MenuOption from './MenuOption';
import Pagination from './Pagination';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import HeroBanner from '~/containers/HeroBanner';

@withI18next(['common'])
class AILandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      option: 0,
    };
  }
  handleClickOption = (value) => {
    this.setState({
      option: value || 0,
    });
  };
  render() {
    const { t, categories, lng, profile, isCountdownActive } = this.props;

    return (
      <div className="ai-landing-page">
        <HeroBanner
          imageURL={`${Config.staticPrefix}/static/images/ai-landing-page/banner.png`}
          title={t('ai_landing_page_title_banner')}
          subTitle={t('ai_landing_page_content_banner')}
          hiddenExplore={true}
        />
        <div className="content-data">
          <MenuOption
            t={t}
            option={this.state.option}
            handleClickOption={this.handleClickOption}
          />
          <Content option={this.state.option} t={t} lng={lng} />
          <Pagination
            option={this.state.option}
            t={t}
            lng={lng}
            handleClickOption={this.handleClickOption}
          />

          <Discover t={t} />
        </div>

        <style jsx global>
          {`
            .link-acwork {
              color: #ffffff;
              text-decoration: underline;
            }
          `}
        </style>
        <style jsx>
          {`
            .content-data {
              margin: 64px 0;
            }
          `}
        </style>
      </div>
    );
  }
}

export default AILandingPage;
